import API from "@/lib/httpModule";

/**
 * Create charter booking
 * @returns
 */
export async function createCharterBooking(payload) {
	return API.post(`/charter-booking`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Update charter booking
 * @returns
 */
export async function updateCharterBooking(requestId, payload) {
	return API.put(`/charter-booking/${requestId}`, payload)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get bookings
 * @returns
 */
export async function getCharterBookings(query) {
	return API.get(`/charter-booking`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get charter detail by id
 * @param {String} slug
 * @returns
 */
export async function getCharterBookingDetail(slug) {
	return API.get(`/charter-booking/${slug}`)
		.then(async (res) => {
			const response = res.data;
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get empty legs invite
 * @returns
 */
export async function getEmptyLegsInvitedUser(query) {
	return API.get(`/empty-leg/invited`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get empty legs alert
 * @returns
 */
export async function getEmptyLegsAlertUser(query) {
	return API.get(`/empty-leg/alert`, query)
		.then(async (rs) => {
			if (rs && rs.status === 200 && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get all empty leg
 * @returns
 */
export async function getAllEmptyLegsUser(query) {
	return API.post(`/empty-leg/get-all`, query)
		.then(async (rs) => {
			if (rs && rs.data) {
				const response = rs.data?.data ?? {};
				return { success: true, data: response };
			}
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get empty leg by id
 * @returns
 */
export async function getEmptyLegsById(id) {
	return API.get(`/empty-leg/${id}`)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}

/**
 * Get empty leg invited by id
 * @returns
 */
export async function getEmptyLegInvitedById(id) {
	return API.get(`/empty-leg/${id}`)
		.then(async (rs) => {
			const response = rs.data?.data ?? {};
			return { success: true, data: response };
		})
		.catch((errRes) => {
			return {
				success: false,
				errors: errRes,
			};
		});
}
